<style scoped>
  .wrapper {
    position: relative;
    margin: 10px 0;
  }
</style>
<template>
  <div class="wrapper">
    <v-skeleton-loader
      v-if="loading && skeleton_type"
      :type="skeleton_type"
    />
    <v-skeleton-loader
      v-if="loading && !skeleton_type"
      v-bind="skeleton_props"
    />

    <v-alert
      v-if="!items.length && !loading"
      color="orange"
      dense
      outlined
      type="info"
    >
      {{ emptyText }}
    </v-alert>

    <div v-if="!loading">
      <div
        v-for="item in items"
        :key="item[itemValue]"
      >
        <slot
          :item="item"
        >
          {{ item }}
        </slot>
      </div>
    </div>
  </div>
</template>
<!-- 示例 -->
<example>
  <v-list-container
    item-value="id"
    :items="items"
    :loading="loading"
    skeleton="article@3"
  >
    <template v-slot="{ item }">
      {{ item.name }}
    </template>
  </v-list-container>
</example>
<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      // v-for 中的 key
      itemValue: {
        type: String,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      emptyText: {
        type: String,
        default: '没有结果'
      },
      skeleton: {
        // 参考 vuetify v-skeleton-loader 组件
        // 值为 string 时: 作为 v-skeleton-loader 的 type prop
        // 值为 object 时: 作为 v-skeleton-loader 的 props
        type: [String, Object],
        default: 'article'
      }
    },
    computed: {
      skeleton_props() {
        if (typeof this.skeleton === 'object') {
          return this.skeleton;
        }
        return {};
      },
      skeleton_type() {
        if (typeof this.skeleton === 'string') {
          return this.skeleton;
        }
        return undefined;
      },
    }
  }
</script>
